import React, { useCallback, useEffect, useState } from 'react';
import {
    BoxedStyled,
    FlowStyled,
    RunCodeStyled
} from '../../../../style/components/common.styled';
import serverStore from '../../../../stores/server.store';
import TagsList from '../../../components/tags/TagsList';
import { useHistory } from 'react-router-dom';
import ServerAgentCollected from '../components/ServerAgentCollected';
import styled from 'styled-components';
import alarmsStore from '../../../../stores/alarms.store';
import {
    EuiButton,
    EuiCodeBlock, EuiCopy,
    EuiFieldText,
    EuiFormRow,
    EuiIcon,
    EuiSpacer
} from '@elastic/eui';
import {MONITOR_TYPES} from "../../../../constants/monitor.types";
import {getAgentInstallCommand} from "../../../../constants/agent.constants";
import { addToast } from '../../../components/toasts/Toast';

const TagsListStyled = styled.div`
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 14px;
  margin: 18px 0;
  text-align: left;

  h3 {
    font-size: 16px;
    padding-bottom: 12px;
    margin: 0;
  }

  > div {
    margin-bottom: 17px;
  }
`;

const BoxedStyledOwn = styled(BoxedStyled)`
  background: transparent;
  box-shadow: none;
  margin: 0;
  padding: 0;
  width: 100%;

  &:hover {
    box-shadow: none;
    transform: none;
  }
`;

const FormCardStyled = styled.section`
  background: linear-gradient(135deg, rgb(35, 37, 47) 0%, rgb(24, 25, 30) 100%);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 18px;

  h3 {
    font-size: 16px;
    margin: 0 0 6px;
  }

  p {
    color: rgba(255, 255, 255, 0.58);
    font-size: 12px;
    line-height: 1.45;
    margin: 0 0 14px;
  }

  .form-actions {
    margin-top: 14px;
  }
`;

const SetupGridStyled = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 0.85fr) minmax(320px, 1fr);
  gap: 16px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const FlowStyledOwn = styled(FlowStyled)`
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  font-size: 13px;
  margin: 0;
  padding: 18px;
  width: 100%;

  h3 {
    font-size: 16px;
    margin: 0 0 10px;
    text-align: left;
  }
`;

const RunCodeStyledOwn = styled(RunCodeStyled)`
  background: linear-gradient(135deg, rgb(35, 37, 47) 0%, rgb(24, 25, 30) 100%);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  margin: 16px 0 0;
  padding: 0;
  text-align: left;
  overflow: hidden;

  .euiCodeBlock {
    max-width: 100%;
  }

  .euiCodeBlock__code {
    white-space: pre-wrap;
    word-break: break-word;
  }
`;

const SuccessHeaderStyled = styled.div`
  align-items: flex-start;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  display: grid;
  gap: 12px;
  grid-template-columns: auto minmax(0, 1fr);
  padding: 16px 18px;

  .success-icon {
    align-items: center;
    background: rgba(80, 188, 94, 0.14);
    border: 1px solid rgba(80, 188, 94, 0.28);
    border-radius: 6px;
    color: #50bc5e;
    display: flex;
    height: 34px;
    justify-content: center;
    width: 34px;
  }

  h3 {
    font-size: 16px;
    margin: 0 0 5px;
  }

  p {
    color: rgba(255, 255, 255, 0.58);
    font-size: 12px;
    line-height: 1.45;
    margin: 0;
  }
`;

const SuccessBodyStyled = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 260px;
  gap: 16px;
  padding: 18px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const CommandPanelStyled = styled.section`
  min-width: 0;

  .panel-label {
    color: rgba(255, 255, 255, 0.72);
    display: block;
    font-size: 13px;
    font-weight: 700;
    margin-bottom: 10px;
  }
`;

const NextStepsStyled = styled.aside`
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding: 14px;

  h4 {
    font-size: 14px;
    margin: 0 0 10px;
  }

  ol {
    color: rgba(255, 255, 255, 0.72);
    font-size: 12px;
    line-height: 1.5;
    margin: 0;
    padding-left: 18px;
  }

  li {
    margin-bottom: 8px;
  }
`;

const SuccessFooterStyled = styled.div`
  align-items: start;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 16px;
  padding: 18px;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

const DoneActionsStyled = styled.div`
  display: flex;
  justify-content: flex-end;

  @media (max-width: 760px) {
    justify-content: flex-start;
  }
`;

const CreateNewServerComponent = ({ setIsTagsModalOpen }) => {
    const history = useHistory();

    const [serverName, setServerName] = useState('');
    const [creationEnabled, setCreationEnabled] = useState(true);
    const [isSending, setIsSending] = useState(false);

    const handleSubmit = useCallback(async () => {
        if (isSending || serverName === '') {
            return;
        }

        setCreationEnabled(false);
        setIsSending(true);

        try {
            const server = await serverStore.createServer(serverName);
            if (!server) {
                return;
            }
            try {
                await alarmsStore.getAlarmsSettings(server._id);
            } catch (error) {
                addToast('Server created, but alarm settings could not be loaded', 'error');
            }
        } catch (error) {
            addToast(error.message || 'Failed to create server', 'error');
            setCreationEnabled(true);
        } finally {
            setIsSending(false);
        }

    }, [isSending, serverName]);

    useEffect(() => {
        return () => {
            serverStore.serverCreated = null;
        };
    }, []);

    const installCommand = serverStore.serverCreated
        ? getAgentInstallCommand(serverStore.serverCreated._id)
        : '';

    return (
        <BoxedStyledOwn>
            <SetupGridStyled>
                <FormCardStyled>
                    <h3>Server identity</h3>
                    <p>Create a label first. The install command appears after the monitor exists.</p>
                    <EuiFormRow label="Server name">
                        <EuiFieldText
                            fullWidth={ true }
                            value={ serverName }
                            isInvalid={ !serverName }
                            disabled={ !creationEnabled }
                            placeholder="Production worker"
                            onChange={ e => setServerName(e.target.value) }
                        />
                    </EuiFormRow>
                    { creationEnabled && (
                        <div className="form-actions">
                            <EuiButton
                                isDisabled={ !serverName }
                                size="s"
                                color="success"
                                onClick={ handleSubmit }
                                iconType="plusInCircle"
                                isLoading={ isSending }
                                fill
                            >
                                Create server
                            </EuiButton>
                        </div>
                    ) }
                </FormCardStyled>

                <FlowStyledOwn>
                    <h3>Setup flow</h3>
                    <ul>
                        <li>Create a server name.</li>
                        <li>Copy the install command generated for this monitor.</li>
                        <li>Run it as root on the target server.</li>
                        <li>Wait for the first metrics payload.</li>
                    </ul>
                </FlowStyledOwn>
            </SetupGridStyled>

            { serverStore.serverCreated && (
                <RunCodeStyledOwn>
                    <SuccessHeaderStyled>
                        <span className="success-icon">
                            <EuiIcon type="check" size="m"/>
                        </span>
                        <div>
                            <h3>Server monitor created</h3>
                            <p>Install the agent on the target server, then SyAgent will start showing metrics as soon as data arrives.</p>
                        </div>
                    </SuccessHeaderStyled>

                    <SuccessBodyStyled>
                        <CommandPanelStyled>
                            <span className="panel-label">Run as root on the target server</span>
                            <EuiCodeBlock language="bash" fontSize="s"
                                          paddingSize="m">
                                { installCommand }
                            </EuiCodeBlock>
                            <EuiSpacer size="m"/>

                            <EuiCopy
                                textToCopy={ installCommand }>
                                { copy => (
                                    <EuiButton onClick={ copy }
                                               size="s"
                                               iconType={ 'copyClipboard' }
                                               color={ 'success' }>Copy command</EuiButton>
                                ) }
                            </EuiCopy>
                        </CommandPanelStyled>

                        <NextStepsStyled>
                            <h4>Next steps</h4>
                            <ol>
                                <li>Copy the command.</li>
                                <li>Run it on the server as root.</li>
                                <li>Return here after the first payload arrives.</li>
                            </ol>
                        </NextStepsStyled>
                    </SuccessBodyStyled>

                    <SuccessFooterStyled>
                        <TagsListStyled>
                            <h3>Select tags</h3>
                            <TagsList
                                serverId={ serverStore.serverCreated._id }
                                serverTags={ serverStore.serverCreated.tags }
                                isServerCreated={ true }
                                monitorType={ MONITOR_TYPES.SERVER }
                            />

                            <EuiButton
                                size="s"
                                onClick={ () => setIsTagsModalOpen(true) }
                                iconType="plusInCircle"
                                fill
                            >
                                Edit tags
                            </EuiButton>
                        </TagsListStyled>

                        <DoneActionsStyled>
                            <EuiButton
                                size="s"
                                color="success"
                                iconType="check"
                                onClick={ e => {
                                    e.preventDefault();
                                    history.push('/servers');
                                } }
                                fill
                            >
                                Done
                            </EuiButton>
                        </DoneActionsStyled>
                    </SuccessFooterStyled>

                    <ServerAgentCollected/>
                </RunCodeStyledOwn>
            ) }
        </BoxedStyledOwn>
    );
};

export default CreateNewServerComponent;
